<script setup lang="ts">
const { to, label } = defineProps<{
  to?: string
  label?: string
}>()

const { t: $t } = useI18n()
</script>

<template>
  <BaseButton
    color="primary"
    class="min-w-32"
    :to="to"
  >
    <Icon name="lucide:plus" class="size-4" />
    <span class=""><slot>{{ label ?? $t('add').toUpperCase() }}</slot></span>
  </BaseButton>
</template>
